import React from 'react';
import { FaWhatsapp, FaHeart, FaStar } from 'react-icons/fa';
import { generateWhatsAppLink } from '../data/products';

const ProductCard = ({ product, onViewDetails }) => {
    const whatsappLink = generateWhatsAppLink(product.name, product.price);

    return (
        <article className="card-product group animate-fade-in">
            <div className="relative overflow-hidden">
                <img src={product.image} alt={product.name} className="card-product-image" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />

                <div className="absolute top-4 right-4">
                    <div className={`${product.badgeColor} text-white px-4 py-2 rounded-full shadow-lg transform group-hover:scale-110 transition-transform`}>
                        <span className="text-xs font-medium">Solo</span>
                        <span className="block text-xl font-bold leading-tight">${product.price}</span>
                    </div>
                </div>

                <div className="absolute top-4 left-4">
                    <button className="bg-white/80 backdrop-blur-sm p-2.5 rounded-full shadow-md hover:bg-dulce-pink-100 transition-all">
                        <FaHeart className="text-dulce-pink-400" size={16} />
                    </button>
                </div>

                <div className="card-product-overlay">
                    <div className="flex gap-3 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                        <a href={whatsappLink} target="_blank" rel="noopener noreferrer"
                            className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-full font-semibold flex items-center gap-2 shadow-lg transform hover:scale-105 transition-all">
                            <FaWhatsapp size={18} />
                            <span>Pedir</span>
                        </a>
                        <button onClick={() => onViewDetails(product)}
                            className="bg-white/90 hover:bg-white text-gray-800 px-6 py-3 rounded-full font-semibold shadow-lg transform hover:scale-105 transition-all">
                            Ver más
                        </button>
                    </div>
                </div>
            </div>

            <div className={`p-5 bg-gradient-to-b ${product.bgGradient}`}>
                <div className="flex items-center gap-1 mb-2">
                    {[...Array(5)].map((_, i) => <FaStar key={i} className="text-amber-400" size={12} />)}
                    <span className="text-xs text-gray-500 ml-1">(5.0)</span>
                </div>

                <h3 className={`font-playfair text-xl font-bold mb-1 ${product.accentColor}`}>{product.name}</h3>
                <p className="text-gray-600 text-sm mb-4 line-clamp-2">{product.description}</p>

                <div className="flex flex-wrap gap-1.5 mb-4">
                    {product.features.slice(0, 3).map((feature, i) => (
                        <span key={i} className={`text-xs px-2.5 py-1 rounded-full border ${product.borderColor} text-gray-600 bg-white/50`}>
                            {feature}
                        </span>
                    ))}
                </div>

                <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                    <div>
                        <span className={`block text-2xl font-bold ${product.accentColor}`}>${product.price}</span>
                    </div>
                    <a href={whatsappLink} target="_blank" rel="noopener noreferrer"
                        className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white py-2.5 px-5 rounded-full text-sm font-semibold shadow-md transform hover:scale-105 transition-all">
                        <FaWhatsapp size={16} />
                        <span>Pedir</span>
                    </a>
                </div>
            </div>
        </article>
    );
};

export default ProductCard;